import { Scene } from 'phaser';
import { Utils } from '../services/Utils';
import { HighScore } from '../models/HighScore';
import i18next from 'i18next';

export class GameOver extends Scene
{
    camera: Phaser.Cameras.Scene2D.Camera;
    background: Phaser.GameObjects.Image;
    gameover_text : Phaser.GameObjects.Text;

    constructor ()
    {
        super('GameOver');
    }

    create ()
    {
        this.camera = this.cameras.main
        this.camera.setBackgroundColor(0x00ff00);

        this.background = this.add.image(512, 384, 'background');
        this.background.setAlpha(0.5);

        this.gameover_text = this.add.text(512, 50, i18next.t("youwin"), {
            fontFamily: 'Arial Black', fontSize: 64, color: '#ffffff',
            stroke: '#000000', strokeThickness: 8,
            align: 'center'
        });
        this.gameover_text.setOrigin(0.5);

        const highscores = Utils.getHighScores();
        const sorted = [...highscores].sort((n1: HighScore,n2: HighScore) => {
            if (n1.score < n2.score) {
                return 1;
            }
        
            if (n1.score > n2.score) {
                return -1;
            }

            return 0;
        }).slice(0, 10);
        const mostRecent = [...highscores].sort((n1: HighScore,n2: HighScore) => {
            if (n1.timestamp < n2.timestamp) {
                return 1;
            }
        
            if (n1.timestamp > n2.timestamp) {
                return -1;
            }

            return 0;
        })[0].timestamp;
        for (let i = 0; i < sorted.length; i++) {
            let color = '#ffffff';
            //if (sorted[i].timestamp == mostRecent) color = '#ffff00';
            let highscore = this.add.text(512, 150 + (i * 30), sorted[i].score.toString(), {
                fontFamily: 'Arial Black', fontSize: 24, color: color,
                stroke: '#000000', strokeThickness: 6,
                align: 'center'
            });
            highscore.setOrigin(0.5);
            if (sorted[i].timestamp == mostRecent) {
                this.tweens.add({
                    targets: highscore,
                    tint: 0xffff00,
                    duration: 300,
                    yoyo: true,
                    ease: 'linear',
                    repeat: -1
                });  
            }
        }

        this.time.delayedCall(3000, () => {
            if (this.input.gamepad) {
                this.input.gamepad.on('down', () => {

                    this.scene.start('MainMenu');
                });
            }
        });
    }
    
    update() {
        // for (let i = 0; i < 4; i++) {
        //     const pad = this.input.gamepad?.getPad(i);
        //     if (pad) {
        //         if (pad.A) {
        //             this.scene.start('MainMenu');
        //         }
        //     }
        // }
    }
}
